/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneInstagram as ResolvedStandaloneInstagram } from 'base/components/standalone/Instagram';

export const Instagram: typeof ResolvedStandaloneInstagram = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneInstagram {...props} />
        </ErrorBoundary>
    );
});

export type InstagramProps = PropsFromComponent<typeof Instagram>;

/** @deprecated Use slot architecture instead */
export const InstagramWith = (extras: DynamicStandaloneExtras): typeof Instagram => {
    return function Instagram(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Instagram');
        return <ResolvedStandaloneInstagram {...mergeProps({ options: { theme } }, props)} />;
    }
}